/**
 * Is the patient profile photo feature on for this site?
 *
 * All-in-One is exactly Forms + Appointment Reminders. Adding a third
 * PATIENT_PHOTO_PAID_FOR row would mean every All-in-One site already on the
 * platform silently loses the feature until someone back-fills it, and every
 * future bundle sale needs two toggles flipped instead of one. So the rule reads
 * the two flags that already exist, and there is deliberately no SuperAdmin
 * toggle / seeder default of its own to keep in sync.
 *
 * Same string-boolean convention as the rest of teamio.settings ('TRUE'/'FALSE');
 * missing row = off, and the compare is trimmed + upper-cased because these two
 * are old rows written by several different onboarding paths.
 *
 * ONE definition, used by the global mixin (`patientProfilePhotoEnabled`) and by
 * Header.vue (which does not carry the mixin) for the search-result camera shortcut.
 *
 * @param {Object} allSettings settings keyed by Property ({ FORMS_PAID_FOR: { PropertyValue } })
 */
export function isPatientPhotoEnabled(allSettings) {
  const s = allSettings;
  const on = (k) => !!(s && s[k] && String(s[k].PropertyValue).trim().toUpperCase() === 'TRUE');
  return on('FORMS_PAID_FOR') && on('APPT_REMINDER_PAID_FOR');
}
